// Turn an axios/FastAPI error into a human-readable message.
//
// FastAPI returns `detail` as a string for HTTPException, but as an ARRAY of
// {loc, msg, type} objects for 422 validation errors. Toasting that array
// directly renders a blank toast — always route errors through here.
export function apiErrorMessage(error, fallback = 'Something went wrong.') {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail) && detail.length) {
    const messages = detail
      .map((d) => {
        const msg = d?.msg || d?.message;
        if (!msg) return null;
        const loc = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : null;
        // loc ends with the field name (or an index for list items).
        return typeof loc === 'string' && loc !== 'body' ? `${loc}: ${msg}` : msg;
      })
      .filter(Boolean);
    if (messages.length) return messages.join(' · ');
  }

  if (error?.response?.status === 401) {
    return 'You need to sign in to do that.';
  }
  if (error?.code === 'ERR_NETWORK' || error?.code === 'ECONNABORTED') {
    return 'Could not reach the server. Check your connection and try again.';
  }

  return fallback;
}
